/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_Sent_TitleInputs */

const fr_auth_forgot_sent_title = /** @type {(inputs: Auth_Forgot_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regardez votre boîte mail`)
};

const en_auth_forgot_sent_title = /** @type {(inputs: Auth_Forgot_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your inbox`)
};

/**
* | output |
* | --- |
* | "Check your inbox" |
*
* @param {Auth_Forgot_Sent_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_sent_title = /** @type {((inputs?: Auth_Forgot_Sent_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_Sent_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_sent_title(inputs)
	return fr_auth_forgot_sent_title(inputs)
});